import React from "react";
import styles from "./BotonCardComponent.module.css";

const MENU_ENCUESTAS = "MENU_ENCUESTAS";
const MENU_SPOTS = "MENU_SPOTS";
const MENU_USUARIOS = "MENU_USUARIOS";
const MENU_LICENCIAS = "MENU_LICENCIAS";
const MENU_CLIENTE = "MENU_CLIENTE";
const MENU_INFORMES = "MENU_INFORMES";
const MENU_INFORMES_PERFIL = "MENU_INFORMES_PERFIL";
const MENU_INFORMES_RESUMEN = "MENU_INFORMES_RESUMEN";
const MENU_INFORMES_ENCUESTAS = "MENU_INFORMES_ENCUESTAS";

const CARD_OPTIONS = {
  [MENU_ENCUESTAS]: {
    titulo: "Encuestas",
    descripcion: "Diseña, publica y gestiona tus encuestas activas.",
    ruta: "encuestas",
    iconColor: "#1d4ed8",
    iconBackground:
      "linear-gradient(135deg, rgba(59, 130, 246, 0.18), rgba(96, 165, 250, 0.1))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 38">
        <path
          d="M23.625,4.5H18a4.5,4.5,0,0,0-9,0H3.375A3.376,3.376,0,0,0,0,7.875v24.75A3.376,3.376,0,0,0,3.375,36h20.25A3.376,3.376,0,0,0,27,32.625V7.875A3.376,3.376,0,0,0,23.625,4.5ZM13.5,2.813A1.688,1.688,0,1,1,11.813,4.5,1.683,1.683,0,0,1,13.5,2.813Zm8.522,16.3-10.055,9.97a.845.845,0,0,1-1.2-.007L4.964,23.217a.845.845,0,0,1,.007-1.2l2-1.983a.845.845,0,0,1,1.2.007L11.4,23.309l7.453-7.4a.845.845,0,0,1,1.2.007l1.983,2A.845.845,0,0,1,22.022,19.111Z"
          transform="translate(1 1)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  [MENU_INFORMES_RESUMEN]: {
    titulo: "Informes de participación",
    descripcion:
      "Indicadores agregados de creación y participación en tus encuestas.",
    ruta: "informes/resumen",
    iconColor: "#22c55e",
    iconBackground:
      "linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(74, 222, 128, 0.1))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4.5 30.75h27" />
          <path d="M9 27L9 17" />
          <path d="M18 27V9" />
          <path d="M27 27V14" />
          <path d="M6 15l9-9 6 6 6-6" />
        </g>
      </svg>
    ),
  },
  [MENU_SPOTS]: {
    titulo: "Spots",
    descripcion: "Administra los totems y puntos de medición.",
    ruta: "spots",
    iconColor: "#0f766e",
    iconBackground:
      "linear-gradient(135deg, rgba(16, 185, 129, 0.18), rgba(45, 212, 191, 0.1))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.087 64.139">
        <path
          d="M28.4,1.928A20.043,20.043,0,0,0,8.355,21.971c0,20.043,20.043,44.1,20.043,44.1s20.043-24.052,20.043-44.1A20.043,20.043,0,0,0,28.4,1.928Zm0,32.32A12.277,12.277,0,1,1,40.675,21.971,12.277,12.277,0,0,1,28.4,34.248ZM20.631,21.971A7.767,7.767,0,1,1,28.4,29.738,7.767,7.767,0,0,1,20.631,21.971Z"
          transform="translate(-8.355 -1.928)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  [MENU_USUARIOS]: {
    titulo: "Usuarios",
    descripcion: "Controla los accesos y roles del equipo.",
    ruta: "usuarios",
    iconColor: "#9333ea",
    iconBackground:
      "linear-gradient(135deg, rgba(168, 85, 247, 0.18), rgba(192, 132, 252, 0.08))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 30.13">
        <g
          transform="translate(0 -2.87)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M25.5,31.5v-3a6,6,0,0,0-6-6H7.5a6,6,0,0,0-6,6v3" />
          <path d="M19.5,10.5a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z" />
          <path d="M34.5,31.5v-3A6,6,0,0,0,30,22.7" />
          <path d="M24,4.7A6,6,0,0,1,24,16.32" />
        </g>
      </svg>
    ),
  },
  [MENU_LICENCIAS]: {
    titulo: "Licencias",
    descripcion: "Revisa vigencias y gestiona activaciones.",
    ruta: "licencias",
    iconColor: "#f97316",
    iconBackground:
      "linear-gradient(135deg, rgba(249, 115, 22, 0.18), rgba(251, 146, 60, 0.08))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.999 32.12">
        <path
          d="M31.5,3l-3,3M17.085,17.415a8.25,8.25,0,1,1-11.668,0,8.25,8.25,0,0,1,11.668,0Zm0,0L23.25,11.25m0,0,4.5,4.5L33,10.5,28.5,6m-5.25,5.25L28.5,6"
          transform="translate(-1.501 -0.879)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  [MENU_CLIENTE]: {
    titulo: "Cliente",
    descripcion: "Configura datos generales de la organización.",
    ruta: "cliente",
    iconColor: "#dc2626",
    iconBackground:
      "linear-gradient(135deg, rgba(239, 68, 68, 0.18), rgba(252, 165, 165, 0.08))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.016 41.68">
        <path
          d="M9.337,18.188h4.08l.627,18.756H8.794l.543-18.756ZM5.93,37.986h39.6V40.07h3.126V43.2h2.084V45.28H.72V43.2H2.8V40.07H5.93Zm41.68-25.2L25.73,3.6,3.846,12.782V14.02H47.61V12.782Zm-39.6,2.28H43.442v2.084H8.014Zm29.943,3.126h4.078l.632,18.756H37.41l.547-18.756Zm-9.536,0H32.5l.625,18.756H27.871Zm-9.538,0h4.079l.621,18.756H18.332l.55-18.756Z"
          transform="translate(-0.72 -3.6)"
          fill="currentColor"
        />
      </svg>
    ),
  },
  [MENU_INFORMES]: {
    titulo: "Informes",
    descripcion: "Analiza resultados, tendencias y desempeño.",
    ruta: "informes",
    iconColor: "#2563eb",
    iconBackground:
      "linear-gradient(135deg, rgba(37, 99, 235, 0.18), rgba(96, 165, 250, 0.1))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 38">
        <path
          d="M23.625,4.5H18a4.5,4.5,0,0,0-9,0H3.375A3.376,3.376,0,0,0,0,7.875v24.75A3.376,3.376,0,0,0,3.375,36h20.25A3.376,3.376,0,0,0,27,32.625V7.875A3.376,3.376,0,0,0,23.625,4.5ZM13.5,2.813A1.688,1.688,0,1,1,11.813,4.5,1.683,1.683,0,0,1,13.5,2.813Zm8.522,16.3-10.055,9.97a.845.845,0,0,1-1.2-.007L4.964,23.217a.845.845,0,0,1,.007-1.2l2-1.983a.845.845,0,0,1,1.2.007L11.4,23.309l7.453-7.4a.845.845,0,0,1,1.2.007l1.983,2A.845.845,0,0,1,22.022,19.111Z"
          transform="translate(1 1)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  [MENU_INFORMES_PERFIL]: {
    titulo: "Informes de perfil",
    descripcion: "Descubre insights por segmentos demográficos.",
    ruta: "informes/perfil",
    iconColor: "#0ea5e9",
    iconBackground:
      "linear-gradient(135deg, rgba(14, 165, 233, 0.18), rgba(125, 211, 252, 0.08))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 30.13">
        <g
          transform="translate(0 -2.87)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M25.5,31.5v-3a6,6,0,0,0-6-6H7.5a6,6,0,0,0-6,6v3" />
          <path d="M19.5,10.5a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z" />
          <path d="M34.5,31.5v-3A6,6,0,0,0,30,22.7" />
          <path d="M24,4.7A6,6,0,0,1,24,16.32" />
        </g>
      </svg>
    ),
  },
  [MENU_INFORMES_ENCUESTAS]: {
    titulo: "Informes de encuestas",
    descripcion: "Explora métricas detalladas por encuesta.",
    ruta: "informes/informes-encuesta",
    iconColor: "#f59e0b",
    iconBackground:
      "linear-gradient(135deg, rgba(245, 158, 11, 0.18), rgba(252, 211, 77, 0.08))",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 38">
        <path
          d="M23.625,4.5H18a4.5,4.5,0,0,0-9,0H3.375A3.376,3.376,0,0,0,0,7.875v24.75A3.376,3.376,0,0,0,3.375,36h20.25A3.376,3.376,0,0,0,27,32.625V7.875A3.376,3.376,0,0,0,23.625,4.5ZM13.5,2.813A1.688,1.688,0,1,1,11.813,4.5,1.683,1.683,0,0,1,13.5,2.813Zm8.522,16.3-10.055,9.97a.845.845,0,0,1-1.2-.007L4.964,23.217a.845.845,0,0,1,.007-1.2l2-1.983a.845.845,0,0,1,1.2.007L11.4,23.309l7.453-7.4a.845.845,0,0,1,1.2.007l1.983,2A.845.845,0,0,1,22.022,19.111Z"
          transform="translate(1 1)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};

const BotonCardComponent = ({
  opcion,
  onClick,
  className = "",
  customRoute,
}) => {
  const option = CARD_OPTIONS[opcion];

  if (!option) {
    return null;
  }

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick(customRoute || option.ruta);
    }
  };

  const iconElement = React.cloneElement(option.svg, {
    className: styles.iconSvg,
    "aria-hidden": true,
  });

  const cardClassName = [styles.container, className].filter(Boolean).join(" ");

  return (
    <button type="button" className={cardClassName} onClick={handleClick}>
      <span
        className={styles.iconWrapper}
        style={{ background: option.iconBackground, color: option.iconColor }}
      >
        {iconElement}
      </span>
      <span className={styles.content}>
        <span className={styles.title}>{option.titulo}</span>
        {option.descripcion && (
          <span className={styles.description}>{option.descripcion}</span>
        )}
      </span>
      <span className={styles.chevron} aria-hidden="true">
        →
      </span>
    </button>
  );
};

BotonCardComponent.MENU_ENCUESTAS = MENU_ENCUESTAS;
BotonCardComponent.MENU_SPOTS = MENU_SPOTS;
BotonCardComponent.MENU_USUARIOS = MENU_USUARIOS;
BotonCardComponent.MENU_LICENCIAS = MENU_LICENCIAS;
BotonCardComponent.MENU_INFORMES = MENU_INFORMES;
BotonCardComponent.MENU_INFORMES_PERFIL = MENU_INFORMES_PERFIL;
BotonCardComponent.MENU_INFORMES_RESUMEN = MENU_INFORMES_RESUMEN;
BotonCardComponent.MENU_INFORMES_ENCUESTAS = MENU_INFORMES_ENCUESTAS;
BotonCardComponent.MENU_CLIENTE = MENU_CLIENTE;

export default BotonCardComponent;
